<script setup lang="ts">
const { width = "100%", height = "inherit" } = defineProps<{
    width?: string;
    height?: string;
}>();
</script>

<template>
    <div class="skeleton" :style="{ '--skeleton-width': width, '--skeleton-height': height }" />
</template>

<style scoped>
.skeleton {
    width: var(--skeleton-width);
    max-width: 100%;
    height: var(--skeleton-height);
    background: linear-gradient(to right, #f5f5f5 8%, #eee 18%, #f5f5f5 33%);
    background-size: 800px 50px;
    border-radius: 6px;
    animation: skeleton-shimmer 1.25s linear infinite forwards;
}

@keyframes skeleton-shimmer {
    from {
        background-position: -468px 0;
    }

    to {
        background-position: 468px 0;
    }
}
</style>
